import { render, staticRenderFns } from "./InfoConfigBadgeChip.vue?vue&type=template&id=0527d6f1&"
import script from "./InfoConfigBadgeChip.vue?vue&type=script&lang=ts&"
export * from "./InfoConfigBadgeChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
